import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionStorage, SessionStorageService } from "ngx-webstorage";
import { RankingTitulares, DetalleRankingTitulares } from "../entities/vam_entities";

const swal = require('sweetalert2');
declare var jQuery: any;

@Component({
    selector: 'RankingTitulares',
    templateUrl: 'rankingTitularesgr.template.html'
})
export class RankingTitularesGrComponent implements OnInit {

    @Input('titularesMayorValorgr')
    TitularesMayorValor: DetalleRankingTitulares[];

    @Input('detalletitularesMayorValorgr')
    DetalleTitularesMayorValor: DetalleRankingTitulares[];

    @Input('titularesMayorNumeroReclamosgr')
    TitularesMayorNumeroReclamos: DetalleRankingTitulares[];

    @Input('detalletitularesMayorNumeroReclamosgr')
    DetalleMayorNumeroReclamos: DetalleRankingTitulares[];


    public lineChartLabels: Array<any>;
    public reembolsoTitChartData: Array<any>;
    public numReclamosTitChartData: Array<any>;
    public lineChartLabelsNumRee: Array<any>;
    public reembolsoTitReeChartData: Array<any>;
    public numReclamosTitReeChartData: Array<any>;
    detalleTitulares: RankingTitulares;

    public lineChartOptions: any = {
        responsive: false,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    id: 'yAxis1',
                    position: 'left'
                },
                {
                    id: 'yAxis2',
                    position: 'right'
                }
            ]
        }
    };
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';



    public lineChartColors: Array<any> = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
    ];


    constructor() {
        this.TitularesMayorValor = [];
        this.DetalleTitularesMayorValor = [];
        this.TitularesMayorNumeroReclamos = [];
        this.DetalleMayorNumeroReclamos = [];
        this.detalleTitulares = new RankingTitulares();
        this.lineChartLabels = new Array<any>();
        this.reembolsoTitChartData = new Array<any>();
        this.numReclamosTitChartData = new Array<any>();
        this.lineChartLabelsNumRee = new Array<any>();
        this.reembolsoTitReeChartData = new Array<any>();
        this.numReclamosTitReeChartData = new Array<any>();

    }

    ngOnInit(): void {
        this.TitularesMayorValor = [];
        this.DetalleTitularesMayorValor = [];
        this.TitularesMayorNumeroReclamos = [];
        this.DetalleMayorNumeroReclamos = [];
        this.lineChartLabels = new Array<any>();
        this.reembolsoTitChartData = new Array<any>();
        this.numReclamosTitChartData = new Array<any>();
        this.lineChartLabelsNumRee = new Array<any>();
        this.reembolsoTitReeChartData = new Array<any>();
        this.numReclamosTitReeChartData = new Array<any>();

    }
    ngOnChanges(): void {
        let banNombreTit: string = "";
        let banBene: string = "";
        let tit: number = 0;
        let bene: number = 1;
        if(this.DetalleTitularesMayorValor!=null){
        this.DetalleTitularesMayorValor.forEach(a => {
            if (a.ApellidoNombresTitular != "TOTAL") {
                if (a.ApellidoNombresTitular != null && banNombreTit.trim() !== a.ApellidoNombresTitular.trim()) {
                    banNombreTit = a.ApellidoNombresTitular;
                    banBene = a.NombreBeneficiario;
                    tit++;
                    bene = 1;
                    a.NombreBeneficiario = "Beneficiario " + bene;
                } else {
                    if (a.NombreBeneficiario != null && banBene.trim() === a.NombreBeneficiario.trim()) {
                        banBene = a.NombreBeneficiario;
                        a.NombreBeneficiario = "Beneficiario " + bene;
                    } else {
                        bene++;
                        banBene = a.NombreBeneficiario;
                        a.NombreBeneficiario = "Beneficiario " + bene;
                    }
                }
                a.ApellidoNombresTitular = "Usuario " + tit;
            }
        });
    }
        banNombreTit = "";
        banBene = "";
        tit = 0;
        bene = 1;
if(this.DetalleMayorNumeroReclamos!=null){
        this.DetalleMayorNumeroReclamos.forEach(a => {
            if (a.ApellidoNombresTitular != "TOTAL") {
                if (a.ApellidoNombresTitular != null && banNombreTit.trim() !== a.ApellidoNombresTitular.trim()) {
                    banNombreTit = a.ApellidoNombresTitular;
                    banBene = a.NombreBeneficiario;
                    tit++;
                    bene = 1;
                    a.NombreBeneficiario = "Beneficiario " + bene;
                } else {
                    if (a.NombreBeneficiario != null && banBene.trim() === a.NombreBeneficiario.trim()) {
                        banBene = a.NombreBeneficiario;
                        a.NombreBeneficiario = "Beneficiario " + bene;
                    } else {
                        bene++;
                        banBene = a.NombreBeneficiario;
                        a.NombreBeneficiario = "Beneficiario " + bene;
                    }
                }
                a.ApellidoNombresTitular = "Usuario " + tit;
            }
        });
    }
        if (this.TitularesMayorValor != undefined && this.TitularesMayorValor != null) {
            this.TitularesMayorValor = this.TitularesMayorValor;
            if (this.TitularesMayorValor != null) {
                let titMayValor = 1;
                this.TitularesMayorValor.forEach(a => {
                    a.ApellidoNombresTitular = "Usuario " + titMayValor;
                    titMayValor++;
                });
                let titulares: Array<any>;
                titulares = new Array<any>();
                for (let i = 0; i < this.TitularesMayorValor.length; i++) {
                    titulares.push(i + 1);
                }

                this.lineChartLabels = titulares;
                let reembolso: Array<any> = this.TitularesMayorValor.map(data => data.ValorReembolsado);
                let siniestros: Array<any> = this.TitularesMayorValor.map(data => data.NumeroReclamos);
                this.reembolsoTitChartData = [{ data: reembolso, label: 'Valor Reembolsado', yAxisID: "yAxis1" },
                { data: siniestros, label: 'Número de Reclamos', yAxisID: "yAxis2" }];
            }

        }
        if (this.TitularesMayorNumeroReclamos != undefined && this.TitularesMayorNumeroReclamos != null) {
            this.TitularesMayorNumeroReclamos = this.TitularesMayorNumeroReclamos;
            if (this.TitularesMayorNumeroReclamos != null) {
                let titulares: Array<any>;
                titulares = new Array<any>();
                for (let i = 0; i < this.TitularesMayorNumeroReclamos.length; i++) {
                    titulares.push(i + 1);
                }
                this.lineChartLabelsNumRee = titulares;
                let reembolso: Array<any> = this.TitularesMayorNumeroReclamos.map(data => data.ValorReembolsado);
                let siniestros: Array<any> = this.TitularesMayorNumeroReclamos.map(data => data.NumeroReclamos);
                this.numReclamosTitReeChartData = [{ data: reembolso, label: 'Valor Reembolsado', yAxisID: "yAxis1" },
                { data: siniestros, label: 'Número de Reclamos', yAxisID: "yAxis2" }];

                let titMayNumReclamos = 1;
                this.TitularesMayorNumeroReclamos.forEach(a => {
                    a.ApellidoNombresTitular = "Usuario " + titMayNumReclamos;
                    titMayNumReclamos++;
                });
            }
        }

        console.log(this.DetalleMayorNumeroReclamos);
    }






}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/rankingTitularesgr.component.ts